import { BaseModel } from './base-model';
import { ZoneFeature } from './zones-base-interfaces';

// Base class for Balast Water Management zones
export abstract class RestrictedAreasModelBase extends BaseModel
{
    abstract getRestrictedAreas(): Promise<ZoneFeature[] | null>;
}

let RestrictedAreasModel: RestrictedAreasModelBase|null = null;

function setRestrictedAreasModel(model: RestrictedAreasModelBase)
{
    RestrictedAreasModel = model;
}

export { RestrictedAreasModel, setRestrictedAreasModel };
